module.exports = __webpack_public_path__ + "assets/img/logo2.188e2184.svg";